const BASE_URL = process.env.REACT_APP_EASY_SUPPORT_BASE_URL!;
const CHANNEL_TOKEN = process.env.REACT_APP_EASY_SUPPORT_CHANNEL_TOKEN!;
const SDK_URL = process.env.REACT_APP_EASY_SUPPORT_SDK_URL!;
const WIDGET_SCRIPT_ID = "easysupport-widget-sdk" as const;
const WIDGET_CONTAINER_ID = "easysupport-widget-container" as const;

export const easySupportConfig = {
  baseUrl: BASE_URL,
  sdkUrl: SDK_URL,
  widgetContainerId: WIDGET_CONTAINER_ID,
  widgetScriptId: WIDGET_SCRIPT_ID,
  initOptions: {
    channelToken: CHANNEL_TOKEN,
    baseUrl: BASE_URL,
    autoOpen: false,
  } satisfies Omit<EasySupportWidgetInitParams, "onReady">,
} as const;

// Module-level registry of nodes injected by the widget so any caller can clean them up.
export const widgetInjectedNodes: Node[] = [];

export const destroyEasySupport = () => {
  window.EasySupportWidget?.destroy?.();
  widgetInjectedNodes.forEach((node) => node.parentNode?.removeChild(node));
  widgetInjectedNodes.length = 0;
  document.getElementById(WIDGET_SCRIPT_ID)?.remove();
  try {
    delete window.EasySupportWidget;
  } catch {
    window.EasySupportWidget = undefined;
  }
};
